import { gsap, snap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import * as Hammer from 'hammerjs';
import { isMobile, isTabletDown } from './isMobile';
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);
class Snapper {
    constructor() {
        this.snapPoints = [];
        this._eventCallbacks = {};
        this._updateCallbacks = [];
        this._lockers = [];
        //this._enableHammer = !isMobile();
        this._enableHammer = true;
        this._baseHeight = 1080;
    }

    init() {
        this._hammer = new Hammer.Manager(document.body, {
            recognizers: [
                [Hammer.Swipe, { direction: Hammer.DIRECTION_VERTICAL }]
            ]
        });
        var triggers = document.querySelectorAll('section');
        triggers.forEach((trigger, i) => {
            this.snapPoints.push(i * document.body.clientHeight);
        });
        this._endSelector = '.nine-section';
        this._speed = 3 * document.body.clientHeight / this._baseHeight;
        if (isTabletDown()) {
            this._endSelector = 'footer'
            gsap.timeline({
                scrollTrigger: {
                    trigger: 'footer',
                    start: 'top top',
                    end: '100%',
                    scrub: 1,
                }
            })
                .to('footer', 2, {
                    zIndex: 11
                });
            this.snapPoints.push(this.snapPoints[this.snapPoints.length - 1] + document.body.clientHeight);
            this.attachLocker(document.querySelector('footer'));
        }
        else {
            this._footer = document.querySelector('footer');
            this._footerFocus = false;
            this._footerObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        if (!this._footerFocus) {
                            this._updateCallbacks.forEach(callback => {
                                callback(this.snapPoints.length);
                            });
                            this._footerFocus = true;
                        }
                    }
                    else if (this._footerFocus) {
                        this._updateCallbacks.forEach(callback => {
                            callback(this.snapPoints.length - 1);
                        });
                        this._footerFocus = false;
                    }
                })
            }, {
                root: document.body,
                threshold: Math.min(1, document.body.clientHeight / this._footer.clientHeight)
            });
            this._footerObserver.observe(this._footer);
        }
        this._previousPoint = 0;
        this._active = this.snapPoints[0] === 0;
        //if (isMobile()) {
        //    ScrollTrigger.create({
        //        trigger: document.body,
        //        start: 0,
        //        end: 50,
        //        onLeave: () => {
        //            document.body.classList.add('locked');
        //            this._bindEvents();
        //            alert('events bound');
        //        },
        //        onEnter: () => {
        //            this._active = true;
        //            this.snapTo(1);
        //        },
        //        onEnterBack: () => {
        //            this._active = false;
        //            document.body.classList.remove('locked');
        //            this._removeEvents();
        //        }
        //    })
        //}
        ScrollTrigger.create({
            trigger: '.hero',
            endTrigger: this._endSelector,
            start: 'top top',
            end: () => isTabletDown() ? 'bottom bottom' : 'top top',
            onLeave: self => {
                if (!isTabletDown()) {
                    this._active = false;
                    this.unlock();
                    this._removeEvents();
                }
            },
            onEnterBack: self => {
                if (!isTabletDown()) {
                    this._active = true;
                    this.snapTo(this.snapPoints.length - 2);
                    this._bindEvents();
                }
            }
        });
        //this._bindEvents(!isMobile());
        this._bindEvents();
    }

    _bindEvents() {
        this._eventCallbacks.wheel = this._wheelHandler.bind(this);
        this._eventCallbacks.keydown = this._keyHandler.bind(this);
        window.addEventListener('wheel', this._eventCallbacks.wheel);
        window.addEventListener('keydown', this._eventCallbacks.keydown);

        if (this._enableHammer) {
            this._eventCallbacks.swipe = this._swipeHandler.bind(this);
            this._hammer.on('swipe', this._eventCallbacks.swipe);
        }
        this._enableHammer = true;
    }

    _removeEvents() {
        Object.keys(this._eventCallbacks).forEach((key) => {
            if (key === 'swipe') {
                this._hammer.off('swipe');
            }
            else {
                window.removeEventListener(key, this._eventCallbacks[key]);
            }
        })
    }

    snapTo(index, callback) {
        if (!this.isLocked() && index > -1 && index !== this._previousPoint) {
            document.body.classList.add('animating');
            this.lock();
            if (index === 0) {
                this._toggled = false;
                if (this._topTrigger) {
                    this._topTrigger.classList.remove('active');
                }
                if (window.introVideo) {
                    window.introVideo.togglePlay();
                }
            }
            else if (!this._toggled) {
                this._toggled = true;
                if (this._topTrigger) {
                    this._topTrigger.classList.add('active');
                }
                if (window.introVideo && window.introVideo.$playing) {
                    window.introVideo.togglePlay();
                }
            }
            var target = !isTabletDown() && index === this.snapPoints.length ? document.body.scrollTop + this._footer.getBoundingClientRect().top : this.snapPoints[index];
            var curIndex = this._previousPoint;
            var targetIndex = Math.min(index, this.snapPoints.length - 1);
            var start = Math.min(targetIndex, this._previousPoint);
            var end = Math.max(targetIndex, this._previousPoint);
            gsap.to(document.body, {
                scrollTo: { y: target, autoKill: false },
                duration: this._speed,
                onUpdate: (e) => {
                    var point = curIndex;
                    for (var i = start; i <= end; i++) {
                        if (this.snapPoints[i] > document.body.scrollTop) {
                            break;
                        }
                        else {
                            point = i;
                        }
                    }
                    if (point !== curIndex) {
                        curIndex = point;
                        this._updateCallbacks.forEach(callback => {
                            callback(curIndex);
                        })
                    }
                },
                onComplete: () => {
                    this._updateCallbacks.forEach(callback => {
                        callback(index);
                    });
                    setTimeout(() => {
                        this._previousPoint = index;
                        if (callback) {
                            callback(index);
                        }
                        this.unlock();
                        if (index >= this.snapPoints.length - 1) {
                            document.body.classList.remove('locked');
                        }
                        document.body.classList.remove('animating');
                    }, 400);
                }
            });
        }
    }

    prev() {
        this.snapTo(this._previousPoint - 1);
    }

    next() {
        this.snapTo(this._previousPoint + 1);
    }

    isLocked() {
        return this._locked;
    }

    lock() {
        this._locked = true;
        document.body.classList.add('locked');
    }

    unlock() {
        this._locked = false;
    }

    attachBackToTopTrigger(element) {
        this._topTrigger = element;
        this._topTrigger.addEventListener('click', () => {
            this.snapTo(0, () => {
                gsap.set('#counter', { y: 0 });
                gsap.set('.six-section__story-link', { autoAlpha: 0 });
                if (isMobile()) {
                    gsap.set('.stories-slider', { autoAlpha: 0 });
                }
                else {
                    gsap.set('.hero-second-scene__circle-graphics', { x: 0, y: 0 });
                }
                this._lockers.forEach(locker => {
                    locker.scrollTo(0, 0);
                })
            });
        });
    }

    attachLocker(element) {
        if (element.scrollHeight > element.clientHeight) {
            element.classList.add('scrollable');
            element._hammer = new Hammer.Manager(element, {
                recognizers: [
                    [Hammer.Swipe, { direction: Hammer.DIRECTION_VERTICAL, enable: true }]
                ]
            });
            element._hammer.on('swipe', function (e) {
                this._preventOuter = true;
                if (!this.isLocked()) {
                    if (e.direction === Hammer.DIRECTION_UP) {
                        if (element.scrollTop > element.scrollHeight - element.clientHeight - 5) {
                            this.next();
                        }
                        else {
                            element._hammer.get('swipe').set({ enable: false });
                            gsap.to(element, {
                                duration: 1,
                                scrollTo: { y: Math.min(element.scrollTop + element.clientHeight, element.scrollHeight - element.clientHeight) }
                            });
                        }
                    }
                    else {
                        if (element.scrollTop < 5) {
                            this.prev();
                        }
                        else {
                            element._hammer.get('swipe').set({ enable: false });
                            gsap.to(element, {
                                duration: 1,
                                scrollTo: { y: Math.max(0, element.scrollTop - element.clientHeight) }
                            });
                        }
                    }
                }
            }.bind(this));
            //element._hammer.on('pan', function (e) {
            //    element.scrollTo(0, element._panStart - e.deltaY);
            //});
            //element._hammer.on('panstart', function (e) {
            //    element._panStart = element.scrollTop;
            //});
            //element._previousScroll = 0;
            element.addEventListener('scroll', (e) => {
                if (!element._wheelTriggered) {
                    if (Math.round(element.scrollTop) === Math.round(element.scrollHeight - element.clientHeight)) {
                        element._hammer.get('swipe').set({ enable: true })
                    }
                    else if (Math.round(element.scrollTop) === 0) {
                        element._hammer.get('swipe').set({ enable: true })
                    }
                }
                element._wheelTriggered = false;
            });

            element.addEventListener('wheel', (e) => {
                clearTimeout(element._wheelTimeout);
                if (!this.isLocked()) {
                    element._wheelTriggered = true;
                    if (e.deltaY > 0 && element._previousScroll === element.scrollTop && element.scrollTop === (element.scrollHeight - element.clientHeight)) {
                        if (element._edge === 1) {
                            this.next();
                        }
                        else {
                            element._wheelTimeout = setTimeout(() => element._edge = 1, 400);
                        }
                    }
                    else if (e.deltaY < 0 && element._previousScroll === element.scrollTop && element.scrollTop === 0) {
                        if (element._edge === -1) {
                            this.prev();
                        }
                        else {
                            element._wheelTimeout = setTimeout(() => element._edge = -1, 400);
                        }
                    }
                    element._edge = 0;
                }
                e.stopPropagation();
                element._previousScroll = element.scrollTop;
            });
            this._lockers.push(element);
        }
    }

    _wheelHandler(e) {
        if (this._active) {
            if (e.deltaY > 0) {
                this.next();
            }
            else {
                this.prev();
            }
        }
    }

    _keyHandler(e) {
        if (this._active) {
            if (e.key === 'ArrowDown') {
                this.next();
            }
            else if (e.key === 'ArrowUp') {
                this.prev();
            }
        }
    }

    _swipeHandler(e) {
        if (this._active && !this._preventOuter) {
            if (e.direction === Hammer.DIRECTION_UP) {
                this.next();
            }
            else {
                this.prev();
            }
        }
        this._preventOuter = false;
    }

    addUpdateCallback(callback) {
        this._updateCallbacks.push(callback);
    }
}

var SnapperInstance = new Snapper();
export { SnapperInstance };